export const ISOURCE_INIT = "ISOURCE_INIT";
export const ISOURCE_FORM_INIT = "ISOURCE_FORM_INIT";

// CREATE REQUEST

export const ISOURCE_CREATE_REQUEST_BEGIN = "ISOURCE_CREATE_REQUEST_BEGIN";
export const ISOURCE_CREATE_REQUEST_SUCCESS = "ISOURCE_CREATE_REQUEST_SUCCESS";
export const ISOURCE_CREATE_REQUEST_FAIL = "ISOURCE_CREATE_REQUEST_FAIL";

// CREATE BUYER REQUEST

export const ISOURCE_CREATE_BUYER_REQUEST_BEGIN = "ISOURCE_CREATE_BUYER_REQUEST_BEGIN";
export const ISOURCE_CREATE_BUYER_REQUEST_SUCCESS = "ISOURCE_CREATE_BUYER_REQUEST_SUCCESS";
export const ISOURCE_CREATE_BUYER_REQUEST_FAIL = "ISOURCE_CREATE_BUYER_REQUEST_FAIL";

// GET LIST

export const ISOURCE_GET_LIST_BEGIN = "ISOURCE_GET_LIST_BEGIN";
export const ISOURCE_GET_LIST_SUCCESS = "ISOURCE_GET_LIST_SUCCESS";
export const ISOURCE_GET_LIST_FAIL = "ISOURCE_GET_LIST_FAIL";

// GET REQUEST

export const ISOURCE_GET_REQUEST_BEGIN = "ISOURCE_GET_REQUEST_BEGIN";
export const ISOURCE_GET_REQUEST_SUCCESS = "ISOURCE_GET_REQUEST_SUCCESS";
export const ISOURCE_GET_REQUEST_FAIL = "ISOURCE_GET_REQUEST_FAIL";

// SUPPLIER


export const ISOURCE_SUPPLIER_SUBMIT_BEGIN = "ISOURCE_SUPPLIER_SUBMIT_BEGIN";
export const ISOURCE_SUPPLIER_SUBMI_SUCCESS = "ISOURCE_SUPPLIER_SUBMI_SUCCESS";
export const ISOURCE_SUPPLIER_SUBMI_FAIL = "ISOURCE_SUPPLIER_SUBMI_FAIL";
